module.exports = __webpack_public_path__ + "static/media/signin_youtube.1b39bd37.png";